import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import AllergiesDropdown from 'components/controls/AllergiesDropdown';

import styles from './AllergyField.scss';
import FormDropDownList from 'components/controls/form/FormDropDownList';

const allergyTypes = [
  'NAME',
  'BASE',
  'GROUP',
];

export default class AllergyField extends PureComponent {
  static propTypes = {
    onSearch: PropTypes.func.isRequired,
  };

  static defaultProps = {

  };

  constructor(props) {
    super(props);

    this.state = {
      type: allergyTypes[0],
      ...props.value,
    };
  }

  handleSearch = search => {
    const {onSearch} = this.props;
    const {type} = this.state

    onSearch(search, type);
  }

  handleChangeType = ({target: {value}}) => {
    const {onChange} = this.props;
    this.setState({type: value});

    onChange({target: {value: null}});
  }

  render() {
    const {type} = this.state;
    const {className, disabled, ...restProps} = this.props;

    return (
      <div className={classnames(styles.container, className)}>
        <FormDropDownList
          items={allergyTypes}
          value={type}
          formatter={loc}
          onChange={this.handleChangeType}
          label={loc('allergy-type')}
          disabled={disabled}
        />
        <AllergiesDropdown
          {...restProps}
          onSearch={this.handleSearch}
          label={loc('allergy-name')}
          disabled={disabled}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/controls/AllergyField.jsx